import { useQuery } from '@tanstack/react-query';
import { mnosQueries } from '../utils/queries';
import { isEmpty } from 'lodash';
import { fetchMnos } from 'src/simInventory/SimInventoryApi/mnoApi';

export const useMnosByIds = (ids: string[]) => {
  const { data, isFetched, isPending } = useQuery({
    queryKey: mnosQueries.list({ ids }),
    queryFn: () => {
      if (isEmpty(ids)) {
        return [];
      }
      return fetchMnos({ ids });
    },
    initialData: [],
    enabled: !isEmpty(ids),
  });

  return { selectedMnos: data, isFetched: isFetched || isEmpty(ids), isPending };
};
